import React from 'react';
import { ResponsivePie } from '@nivo/pie';

export const Pie = (props) => {
  const { data = [] } = props;
  const filteredData = data.filter(({ value }) => value != null);

  return (
    <ResponsivePie
      enableArcLabels={false}
      enableArcLinkLabels={false}
      data={filteredData}
      margin={{ top: 12, right: 30, bottom: 50, left: 0 }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      colors={{ scheme: 'set2' }}
      borderWidth={1}
      radialLabelsSkipAngle={10}
      radialLabelsTextXOffset={6}
      radialLabelsTextColor="#333333"
      radialLabelsLinkOffset={0}
      radialLabelsLinkDiagonalLength={16}
      radialLabelsLinkHorizontalLength={24}
      radialLabelsLinkStrokeWidth={1}
      sliceLabel="label"
      enableRadialLabels={false}
      slicesLabelsSkipAngle={10}
      slicesLabelsTextColor="#fff"
      animate={false}
      motionStiffness={90}
      motionDamping={15}
      fit
      legends={[
        {
          anchor: 'right',
          direction: 'column',
          translateY: 0,
          itemWidth: 60,
          itemHeight: 14,
          itemTextColor: '#999',
          symbolSize: 12,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}
    />
  );
};
